function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 5,
  width: 24,
  height: 2,
  rx: 1
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 11,
  width: 16,
  height: 2,
  rx: 1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 17,
  width: 22,
  height: 2,
  rx: 1
});

function SvgHorizontalAlignRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIiIHJ4PSIxIiAvPgo8cmVjdCB4PSI4IiB5PSIxMSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjIiIHJ4PSIxIi8+CjxyZWN0IHg9IjIiIHk9IjE3IiB3aWR0aD0iMjIiIGhlaWdodD0iMiIgcng9IjEiLz4KPC9zdmc+Cg==";
export { SvgHorizontalAlignRight as ReactComponent };